/* tslint:disable */
/* eslint-disable */
/* @relayHash c5d3cc224db9a95a687e15b126fa21f6 */

import { ConcreteRequest } from "relay-runtime";
export type userTrackingQueryVariables = {
    hasCheckoutUserId: boolean;
    checkoutUserId: string;
    hasUserId: boolean;
    isLoggedIn: boolean;
    userId: string;
};
export type userTrackingQueryResponse = {
    readonly viewer: {
        readonly transactionsCounter?: {
            readonly submittedTransactions?: number | null;
            readonly confirmedTransactions?: number | null;
            readonly guestCheckoutTransactions: number | null;
        } | null;
        readonly user?: {
            readonly isVerifiedTrade: boolean | null;
        } | null;
    };
};
export type userTrackingQuery = {
    readonly response: userTrackingQueryResponse;
    readonly variables: userTrackingQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "hasCheckoutUserId",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "checkoutUserId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasUserId",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isLoggedIn",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Condition",
  "passingValue": true,
  "condition": "hasCheckoutUserId",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "transactionsCounter",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "checkoutUserId"
        }
      ],
      "concreteType": "TransactionsCounter",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "guestCheckoutTransactions",
          "name": "guest",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "hasUserId",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": "submittedTransactions",
              "name": "submitted",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": "confirmedTransactions",
              "name": "confirmed",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
},
v2 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isVerifiedTrade",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "userTrackingQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isLoggedIn",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "userTrackingQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v1/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isLoggedIn",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "userTrackingQuery",
    "id": "ferrum/293.0.0-2020-12-03T17:06:45.415Z/userTrackingQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '2e221747b7b26afdf87834db0b530298';
export default node;
